<template>
  <div class="new-reservation">
    <div class="row">
      <div class="col-md-5">
        <vue-form ref="form"
          :options="{ permalink: 'searchReservation', params: { driver: $route.query.d, car: $route.query.c } }"
          @load="formLoaded()"
          @updated="formUpdated()"
          @complete="updateMap()">
        </vue-form>
      </div>
      <div class="col-md-7">
        <div class="card card-primary">
          <div class="card-header">
            <span class="fa fa-car"></span> Cars
            <span class="badge badge-primary" v-if="reservationSearchResultsTotal">
              {{ reservationSearchResultsTotal }} Result<span v-if="reservationSearchResultsTotal !== 1">s</span>
            </span>
          </div>
          <div class="nav-tabs-custom card-body p-1">
            <nav-tab :tab-count="2" @change="tabChanged($event)" ref="tabs">
              <!-- Car List -->
              <div title="List" slot="tab1" icon="fa-list">
                <template v-if="reservationSearchResults.length">
                  <div class="mt-2">
                    <paging-input @change="updatePage($event)" :options="{
                      totalResults: reservationSearchResultsTotal,
                      centered: true,
                      current
                    }">
                    </paging-input>
                  </div>
                  <template v-for="car in reservationSearchResults">
                    <car-item
                      :key="car.uuid"
                      :object="car"
                      :start="reservationSearchRates.start"
                      :end="reservationSearchRates.end"
                      :rates="reservationSearchRates.rates"
                      :discount="memberDiscount"
                      @reserve="reserve(car)"
                      :driver="reservationSearchRates.driver">
                    </car-item>
                  </template>
                  <div class="mt-2">
                    <paging-input @change="updatePage($event)" :options="{
                      totalResults: reservationSearchResultsTotal,
                      centered: true,
                      current
                    }">
                    </paging-input>
                  </div>
                </template>
                <template v-else>
                  <div class="alert alert-danger my-1">
                    No results.
                  </div>
                </template>
              </div>
              <!-- Car Map -->
              <div title="Map" slot="tab2" icon="fa-map">
                <reservation-map ref="map"
                  :cars="reservationSearchResultsAll"
                  @location="updateLocation($event)"
                  @reserve="reserve($event)"
                  :start="reservationSearchRates.start"
                  :end="reservationSearchRates.end"
                  :height="450">
                </reservation-map>
              </div>
            </nav-tab>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CarItem from '@/components/displays/CarItem'
import PagingInput from '@/components/inputs/PagingInput'
import NavTab from '@/components/NavTab'
import VueForm from '@/components/Form'
import ReservationMap from '@/components/ReservationMap'
import { MODIFY_FORM_VALUE, RESERVE_CAR } from '@/vuex/types'
import { mapGetters } from 'vuex'

export default {
  name: 'NewReservation',
  components: {
    NavTab,
    PagingInput,
    CarItem,
    ReservationMap,
    VueForm
  },
  computed: {
    current () {
      return this.currentPage || 1
    },
    memberDiscount () {
      let field = this.$store.getters.getFormField({ permalink: 'searchReservation', name: 'AccountUuid' })
      let discount = null
      if (field && field.objects && field.value) {
        for (let driver of field.objects) {
          if (driver.uuid === field.value) discount = driver.MemberDiscount
        }
      }
      return discount
    },
    ...mapGetters([
      'reservationSearchRates',
      'reservationSearchResults',
      'reservationSearchResultsAll',
      'reservationSearchResultsTotal'
    ])
  },
  data () {
    return {
      currentPage: 1
    }
  },
  methods: {
    async formUpdated () {
      await this.$nextTick()
      if (!this.$refs.form.sending) {
        this.currentPage = 1
        this.$store.commit(MODIFY_FORM_VALUE, {
          permalink: 'searchReservation',
          name: 'offset',
          value: 0
        })
        this.$refs.form.submitForm()
      }
    },
    async formLoaded () {
      this.$refs.map.getLocation()
      if (this.$route.query.d || this.$route.query.c) {
        await this.$nextTick()
        this.$refs.form.validateForm()
        this.$refs.form.submitForm()
      }
      if (this.$route.path.includes('maintenance')) {
        this.$store.commit(MODIFY_FORM_VALUE, {
          permalink: 'searchReservation',
          name: 'maintenance',
          value: true
        })
      }
    },
    updateMap () {
      if (this.$refs.tabs.activeTab === 2) this.$refs.map.init(this.reservationSearchResultsAll)
    },
    async tabChanged (tab) {
      if (tab === 2) this.$refs.map.init(this.reservationSearchResultsAll)
    },
    updateLocation (location) {
      this.$store.commit(MODIFY_FORM_VALUE, {
        permalink: 'searchReservation',
        name: 'address',
        value: {
          value: '',
          latitude: location.lat,
          longitude: location.lng
        }
      })
    },
    async updatePage (page) {
      this.currentPage = page
      this.$store.commit(MODIFY_FORM_VALUE, {
        permalink: 'searchReservation',
        name: 'offset',
        value: (page - 1) * 10
      })
      await this.$nextTick()
      this.$refs.form.submitForm()
    },
    reserve (car) {
      let maintenance = this.$store.getters.getFormValue({ permalink: 'searchReservation', name: 'maintenance' })
      this.$store.dispatch(RESERVE_CAR, {
        car,
        driver: this.reservationSearchRates.driver,
        start: this.reservationSearchRates.start,
        end: this.reservationSearchRates.end,
        maintenance
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/NewReservation.vue